import React from 'react';
import ContentMessage from '../../_lib/components/ContentMessage/ContentMessage';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { PaginationItemWithPageLink, Pagination } from '../../_lib/components/Pagination';
import { DefaultView, OptionalEditView, Views } from '../../types/BlockWithViews';
import { TopHeadline } from './TopHeadlineType';
import { TopHeadlineList } from './partials/TopHeadlineList';

type Embedded = {
  items: TopHeadline[];
  pageItems?: PaginationItemWithPageLink[];
};
export type TopHeadlinesBlockProps = Views<DefaultView<Embedded> & OptionalEditView<Embedded>>;

function TopHeadlinesArchive({ activeView = 'default', views }: TopHeadlinesBlockProps) {
  const { t } = useSonTranslation('TopHeadlinesForm');
  const { items, pageItems } = activeView === 'edit' && views.edit ? views.edit.embedded : views.default.embedded;

  return (
    <>
      {(!items || items.length === 0) && <ContentMessage text={t('noItems')} />}
      <div className="top-headlines">
        {items && <TopHeadlineList topHeadlines={items} isEditView={activeView === 'edit'} />}
        {pageItems && <Pagination pageItems={pageItems} />}
      </div>
    </>
  );
}

export const TopHeadlinesArchiveBlock = asFetchableBlock(TopHeadlinesArchive, BlockType.topheadlinesarchive);
